/**
 *
 */
!function(config) {
	console.log('GSIDSSO init [config]', config);

	if (!config.urlSsoauth || !config.urlAssert) {
		console.log('GSIDSSO exit');
		return;
	}

	GSIDSSO.init(config.urlSsoauth);
	
	GSIDSSO.getAccessToken().then(function(accessToken) {
		console.log('GSIDSSO.getAccessToken() [accessToken]', accessToken);
        
        if (!accessToken) {
            return;
        }
        
		var xhr = new XMLHttpRequest();
        xhr.open('POST', config.urlAssert);
        xhr.setRequestHeader('Access-Token', accessToken);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function() {
            if (xhr.status === 200) {
				let data = JSON.parse(xhr.responseText);
					
                console.log('Login response: ', data);
				if (data.action && data.action === 'reload') {
					let url = getURLWithoutParameter('accesstoken');
					console.log('new url:', url);
					window.location.replace(url);
					window.location.reload(true);
				}
            } else if (xhr.status !== 200) {
                console.log('Login request failed!', xhr.status, xhr.responseText);
            }
        };
        xhr.send();
	});



	function getURLWithoutParameter(key) {
		console.log('getURLWithoutParameter', key);

		let query = window.location.search.substring (1),
			parameters = query.split ('&'),
			response = '';
		
		for (let i = 0; i < parameters.length; i++) {
			let pair = parameters[i].split('=');

			if (pair[0] !== key) {
				response += parameters[i];
			}
		}

		return window.location.href.split('?')[0] + (response ? '?' + response : '');
	}



	var btnSignOut = document.querySelector ('[href^="' + location.protocol + '//' + location.hostname + '/auth/logout"]');
	if (btnSignOut) {
		btnSignOut.addEventListener ('click', function (event) {
			event.preventDefault()
			GSIDSSO.logout()
			// todo: check sso sign out success
			window.setTimeout(() => window.location.assign(event.target.href), 666)
		}, false);
	}
}(document.currentScript.dataset);

